/**
 * Splash Screen Manager für Custom Domains
 * Entfernt Server-Side Splash nach React Hydration
 */

export const initializeSplashManager = () => {
  // Nur auf echten Custom Domains aktiv
  const hostname = window.location.hostname;
  const excludedDomains = [
    'bonusclub.link',
    'localhost', 
    '127.0.0.1',
    'bonusclub-dev.web.app',
    'bonusclub-ab5e2.web.app'
  ];
  
  if (excludedDomains.some(excluded => hostname.includes(excluded))) {
    return;
  }

  console.log('🎨 SplashManager: Initializing for custom domain');

  // Remove splash after React hydrates
  const removeSplash = () => {
    const splash = document.getElementById('bc-splash');
    if (splash) {
      console.log('🎨 SplashManager: Removing splash screen');
      
      // Smooth fade out
      splash.style.opacity = '0';
      splash.style.transition = 'opacity 0.4s ease-out';
      
      // Remove from DOM after animation
      setTimeout(() => {
        splash.remove();
        // Re-enable scrolling
        document.body.style.overflow = 'auto';
        console.log('🎨 SplashManager: Splash removed successfully');
      }, 400);
    }
  };

  // Multiple triggers to ensure splash is removed
  // 1. When DOM is ready
  if (document.readyState === 'complete') {
    setTimeout(removeSplash, 100);
  } else {
    window.addEventListener('load', () => {
      setTimeout(removeSplash, 100);
    });
  }

  // 2. React hydration signal
  window.addEventListener('bc-react-ready', removeSplash);

  // 3. Fallback timer (safety net)
  setTimeout(() => {
    const splash = document.getElementById('bc-splash');
    if (splash) {
      console.warn('🎨 SplashManager: Fallback removal triggered');
      removeSplash();
    }
  }, 3000);
};

/**
 * Signal that React is ready (call this after App mounts)
 */
export const signalReactReady = () => {
  window.dispatchEvent(new CustomEvent('bc-react-ready'));
};

/**
 * Get tenant data from server-side rendering
 */
export const getTenantData = () => {
  return window.__BC_TENANT__ || null;
};

/**
 * Check if running on custom domain
 */
export const isRunningOnCustomDomain = () => {
  const hostname = window.location.hostname;
  const excludedDomains = [
    'bonusclub.link',
    'localhost', 
    '127.0.0.1',
    'bonusclub-dev.web.app',
    'bonusclub-ab5e2.web.app'
  ];
  
  return !excludedDomains.some(excluded => hostname.includes(excluded));
};
